// extracted by mini-css-extract-plugin
module.exports = {"LandingImage":"Landing_LandingImage__2Fs9i","LandingButtonMargin":"Landing_LandingButtonMargin__3WC8v","footer":"Landing_footer__3an94"};